import React from 'react';
import { Backdrop } from '@material-ui/core/';
import { makeStyles } from '@material-ui/core/styles';
import loaderGif from "../../assets/images/loader.gif"
import { WHITE, LOADER_SHADOW } from '../../constants/constants';


const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: WHITE,
    opacity: "0.8 !important",
  },
  loader: {
    display: "flex",
    alignItems: "center",
    boxShadow: `0px 2px 20px ${LOADER_SHADOW}`,
    height: 50,
    width: 120,
    borderRadius: 10,
    backgroundColor: WHITE,
    justifyContent: "space-between",
    opacity: "1 !important",
  },
  loaderGif: {
    height: 50,
    width: 120,
    borderRadius: 10,
  }
}));

const Loader = () => {
  const classes = useStyles();
  return (
    <Backdrop invisible className={classes.backdrop} open={true} onClick={() => { }}>
      <div className={classes.loader}>
        <img className={classes.loaderGif} src={loaderGif} alt="Loading..." />
      </div>
    </Backdrop>
  )
}

export default Loader;